import { ReactNode } from 'react';

export const isReactText = (children: ReactNode) => ['string', 'number'].includes(typeof children);
